export const iconFontAwesomeShapesPlay = (
	<i className="fa-solid fa-play"></i>
);
